// Mock API functions for fetching data
export const fetchDevices = async () => {
  try {
    const response = await fetch("/data/devices.json")
    if (!response.ok) {
      throw new Error("Failed to fetch devices")
    }
    const data = await response.json()

    // Simulate real-time data variations
    return data.map((device) => ({
      ...device,
      battery: Math.max(0, Math.min(100, device.battery + (Math.random() - 0.5) * 2)),
      lastSignal: new Date().toISOString(),
      sensors: {
        chemical: {
          ...device.sensors.chemical,
          value: Math.max(0, device.sensors.chemical.value + (Math.random() - 0.5) * 0.05),
        },
        vibration: {
          ...device.sensors.vibration,
          value: Math.max(0, device.sensors.vibration.value + (Math.random() - 0.5) * 0.1),
        },
      },
    }))
  } catch (error) {
    console.error("Error fetching devices:", error)
    return []
  }
}

export const fetchAlerts = async () => {
  try {
    const response = await fetch("/data/alerts.json")
    if (!response.ok) {
      throw new Error("Failed to fetch alerts")
    }
    const data = await response.json()

    // Sort alerts by timestamp (newest first)
    return data.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp))
  } catch (error) {
    console.error("Error fetching alerts:", error)
    return []
  }
}
